module.exports = __webpack_public_path__ + "static/img/logo49.549095c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo49.png
// module id = GBDe
// module chunks = 1